import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { PRODUCT_BRANDS_QUERY_KEY } from '@/app/entities/brands/model'
import { PRODUCT_SELLERS_QUERY_KEY } from '@/common/entities/sellers'

export const useRefetchCompanyStatsOnVisit = (orgId: string | undefined) => {
    const queryClient = useQueryClient()

    useEffect(() => {
        if (!orgId) return

        void queryClient.invalidateQueries({ queryKey: ['company-stats'] })
        void queryClient.invalidateQueries({ queryKey: [PRODUCT_BRANDS_QUERY_KEY, orgId] })
        void queryClient.invalidateQueries({ queryKey: [PRODUCT_SELLERS_QUERY_KEY, orgId] })
    }, [orgId, queryClient])
}
